import { render, staticRenderFns } from "./ProductReceipt.vue?vue&type=template&id=66143a56&scoped=true&"
import script from "./ProductReceipt.vue?vue&type=script&lang=js&"
export * from "./ProductReceipt.vue?vue&type=script&lang=js&"
import style0 from "./ProductReceipt.vue?vue&type=style&index=0&lang=sass&"
import style1 from "./ProductReceipt.vue?vue&type=style&index=1&id=66143a56&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66143a56",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VListItem } from 'vuetify/lib/components/VList';
import { VRadio } from 'vuetify/lib/components/VRadioGroup';
import { VRadioGroup } from 'vuetify/lib/components/VRadioGroup';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VCard,VCheckbox,VDivider,VListItem,VRadio,VRadioGroup,VSpacer,VTextField})
